import "./init";
import { GLOBAL_API_PROP_NAME } from "@sinch/core/config/globals";

if (import.meta.env.MODE === "development" && !(typeof window !== "undefined" && (window as any).Cypress)) {
  setTimeout(async () => {
    const { scan } = await import("react-scan");
    scan({
      enabled: true,
      trackUnnecessaryRenders: true,
    });
  }, 1000);
}
export { API_ROOT, ERROR_MONITOR_API_KEY, ERROR_MONITOR_DEBUG, ERROR_MONITOR_ENV, GOOGLE_MAPS_API_KEY } from "./env";

declare global {
  interface Window {
    [GLOBAL_API_PROP_NAME]: Record<string, any>;
  }
}

window[GLOBAL_API_PROP_NAME] = window[GLOBAL_API_PROP_NAME] || {}; // Global namespace for communication with scripts outside of react
